import * as yup from 'yup';
import { createCompanyGroupFormFields } from '../../fields/formFields/createCompanyGroup';

export const createCompanyGroupSchema = yup.object({
  [createCompanyGroupFormFields.name]: yup
    .string()
    .max(150, 'Name must be at most 150 characters')
    .required('Name is required')
    .trim(),
  [createCompanyGroupFormFields.contribution]: yup
    .number()
    .positive('Contribution must be positive')
    .required('Contribution is required'),
  [createCompanyGroupFormFields.maxCap]: yup
    .number()
    .positive('Max Cap must be positive')
    .required('Max Cap is required'),
  [createCompanyGroupFormFields.lockupPeriod]: yup
    .number()
    .integer('Lockup Period must be an integer')
    .min(0, 'Lockup Period must be 0 or greater')
    .required('Lockup Period is required'),
  [createCompanyGroupFormFields.coContributionDueDate]: yup.string().required('Co-Contribution Due Date is required'),
  [createCompanyGroupFormFields.numberOfWithdrawalsAllowed]: yup
    .number()
    .integer('Number of Withdrawals Allowed must be an integer')
    .min(0, 'Number of Withdrawals Allowed must be 0 or greater')
    .required('Number of Withdrawals Allowed is required'),
  [createCompanyGroupFormFields.externalPortfolioIds]: yup
    .array()
    .of(yup.number())
    .length(1, 'One product is required')
    .required('One product is required'),
});
